import { LibraryObject } from "./../../model/library";

export default abstract class ContentService {
  abstract createFolder(object: LibraryObject, parentKey: string): Promise<object>;
  abstract createFile(
    object: LibraryObject,
    parentKey: string,
    contentFiles: File[],
    assetFiles: File[]
  ): Promise<object>;
  abstract editFile(
    parentKey: string,
    contentFiles: File[],
    assetFiles: File[]
  ): Promise<object>;
  abstract getFolderContent(key: string, maxNumberOfKeys?: number): Promise<object>;
  abstract removeFolder(key: string): Promise<object>;
  abstract getObjectMetadata(key: string): Promise<{ libraryObject: LibraryObject }>;
  abstract headObject(key: string): Promise<object>;
  abstract getObject(key: string): Promise<object>;
  abstract editFolderMetadata(object: LibraryObject): Promise<object>;
  abstract renameFolder(object: LibraryObject): Promise<object>;
  abstract getAssetFileURL(parentKey: string, fileName: string): Promise<string>;
  abstract copyFolder(sourceFolderKey: string, targetFolderKey: string): Promise<object>;
  abstract moveFolder(sourceFolderKey: string, targetFolderKey: string): Promise<object>;
  abstract clearCredentials(): void;
}
